import { trimEnd } from 'lodash';

import { logger } from '../../utils/logger';

const AppleDeveloperMerchantIdAssociation = () => null;

AppleDeveloperMerchantIdAssociation.getInitialProps = async ({ res }) => {
  res.setHeader('Content-Type', 'text/plain');
  try {
    const baseURL = trimEnd(process.env.api.baseUrl, '/');
    const response = await fetch(`${baseURL}/apple-pay-domain-association`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.text();
    res.write(data);
  } catch (error) {
    logger.error('failed to get apple-pay-domain-association', error.message);
    // Setting the status on the response object is the point here. The repo's own
    // eslint run never sees this file (eslint ignores dot-directories, so
    // `.well-known/` is skipped), but `next build` lints it and fails the build.
    // eslint-disable-next-line no-param-reassign
    res.status = 501;
    res.write('error');
  }

  res.end();
};

export default AppleDeveloperMerchantIdAssociation;
